import { render, staticRenderFns } from "./InquiriesViewInfoCards.vue?vue&type=template&id=1490bc95&scoped=true"
import script from "./InquiriesViewInfoCards.vue?vue&type=script&lang=js"
export * from "./InquiriesViewInfoCards.vue?vue&type=script&lang=js"
import style0 from "./InquiriesViewInfoCards.vue?vue&type=style&index=0&id=1490bc95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1490bc95",
  null
  
)

export default component.exports